import React, { useState } from "react";
import {
  FormControlLabel,
  Grid,
  IconButton,
  InputAdornment,
  Stack
} from "@mui/material";
import {
  StyledCheckbox,
  StyledHeader,
  StyledInput,
  StyledLoginBox
} from "./Login.styles";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import Button from "../../components/shared/Button/Button";
import API from "api";

export default function Reset() {
  const [newP, setNewP] = useState<string>("");
  const [reenter, setReenter] = useState<string>("");
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const handleClickShowPassword = () => setShowPassword(!showPassword);
  const handleMouseDownPassword = () => setShowPassword(!showPassword);

  const submit = () => {
    if (newP === reenter) {
      // API call to save new password
      const grant = window.location.pathname.split("/")[2];
      API.kore.coordinator
        .submitPassword(newP, grant)
        .then((ret) => {
          window.location.pathname = "/login";
        })
        .catch((err) => alert(err));
    } else {
      alert("Passwords do not match, please try again");
    }
  };

  return (
    <Grid container>
      <Grid item xs={1}></Grid>
      <Grid item xs={10}>
        <StyledLoginBox>
          <StyledHeader>Password Reset</StyledHeader>
          <Grid container>
            <Grid item xs={3}></Grid>
            <Grid item xs={6} sx={{ textAlign: "center" }}>
              <Stack>
                <h4>Please enter a new password</h4>
                <FormControlLabel
                  control={
                    <StyledInput
                      onChange={(e) => {
                        setNewP(e.target.value);
                      }}
                      value={newP}
                      size={"small"}
                      type={showPassword ? "text" : "password"}
                      InputProps={{
                        // <-- This is where the toggle button is added.
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={handleClickShowPassword}
                              onMouseDown={handleMouseDownPassword}
                            >
                              {showPassword ? (
                                <Visibility />
                              ) : (
                                <VisibilityOff />
                              )}
                            </IconButton>
                          </InputAdornment>
                        )
                      }}
                    />
                  }
                  label={"New Password"}
                  labelPlacement="start"
                  sx={{ width: "75%" }}
                />
                <FormControlLabel
                  control={
                    <StyledInput
                      onChange={(e) => {
                        setReenter(e.target.value);
                      }}
                      value={reenter}
                      size={"small"}
                      type={showPassword ? "text" : "password"}
                      InputProps={{
                        // <-- This is where the toggle button is added.
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={handleClickShowPassword}
                              onMouseDown={handleMouseDownPassword}
                            >
                              {showPassword ? (
                                <Visibility />
                              ) : (
                                <VisibilityOff />
                              )}
                            </IconButton>
                          </InputAdornment>
                        )
                      }}
                    />
                  }
                  label={"Reenter Password"}
                  labelPlacement="start"
                  sx={{ width: "75%" }}
                />
              </Stack>
              <br />
              <Button variant="primary" onClick={submit}>
                Update
              </Button>
            </Grid>
            <Grid item xs={3}></Grid>
          </Grid>
        </StyledLoginBox>
      </Grid>
      <Grid item xs={2}></Grid>
    </Grid>
  );
}
